import { Plus } from "lucide-react";

export function ProductsHeader({ onAddProduct }) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold text-[#111111] dark:text-white font-poppins mb-2">
          Products
        </h1>
        <p className="text-sm md:text-base text-[#666666] dark:text-[#A0A0A0] font-inter">
          Manage your rental inventory and product details
        </p>
      </div>

      <button
        onClick={onAddProduct}
        className="flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-[#62397f] to-[#7C3AED] text-white rounded-xl font-semibold text-sm font-inter transition-all duration-200 hover:shadow-lg hover:scale-105 active:scale-95 self-start lg:self-auto"
      >
        <Plus size={18} />
        Add Product
      </button>
    </div>
  );
}
